export default __webpack_public_path__ + "static/media/FinalLogo.b450cf68.png";